import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

/**
 * Only fire effect the first time the (optional) condition met.
 */
const useEffectOnce = (
  effect: EffectCallback,
  dependencies: DependencyList,
  condition: boolean = true
) => {
  const isSubsequentRender = useRef(false);

  useEffect(() => {
    if (!condition || isSubsequentRender.current) {
      return undefined;
    }

    isSubsequentRender.current = true;

    return effect();
  }, dependencies.concat(condition)); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useEffectOnce;
